import React from "react"
import { Link as RouterLink } from "react-router-dom"

export default function Link({
    to,
    children,
    variant = "default",
    className = "",
    ...props
}) {
    const variantMap = {
        default: "text-gray-700 hover:text-gray-900 transition-colors",
        primary: "text-blue-600 hover:text-blue-800 transition-colors",
        login_nav: "text-white px-3 py-2 rounded-md bg-second_light hover:text-blue-800 hover:bg-gray-100 transition-colors",
        secondary: "text-gray-500 hover:text-gray-700 transition-colors",
        danger: "text-red-600 hover:text-red-800 transition-colors",
        nav: "text-gray-700 hover:text-gray-900 transition-colors px-3 py-2 rounded-md hover:bg-gray-100",
    }

    const linkClass = `${variantMap[variant] || variantMap.default} ${className}`

    return (
        <RouterLink
            to={to}
            className={linkClass}
            {...props}
        >
            {children}
        </RouterLink>
    )
}

